// src/hooks/invoiceUploadHook.tsx
import { useState, useEffect } from 'react';
import { DropdownValues } from "../types/main"
import { authAxios } from "../../../utils/session_utils";



export const useDropdownValues = () => {
  const [dropdownValues, setDropdownValues] = useState<DropdownValues>({
    partners: [],
    channels: [],
    territories: [],
    platforms: [],
    domains: [],
    labels: [],
    platformsByDomain: {},
    partnersByDomain: {},
    channelsByDomain: {},
    channelsByPartner: {},
    territoriesByPartner: {},
    partnersByPlatform: {},
    platformsPartnersTerritories: {},
  });

  useEffect(() => {
    const fetchDropdownValues = async () => {
      try {
        const response = await authAxios({
          method: "GET",
          url: `${process.env.REACT_APP_BACK_END_API}/register-data/dropdown_values`,
          headers: {
            "Content-Type": "application/json",
          },
        });

        const { data } = response;

        setDropdownValues(data);
      } catch (error) {
        console.error('Error fetching dropdown values:', error);
      }
    };

    fetchDropdownValues();
  }, []);

  return dropdownValues;
};


